import { TrackByFunction } from '@angular/core';

import { trackByFunctions } from '@assess/browser/track-by-functions';

import { Constructor } from './constructor.type';
import { DynamicProperty } from '../decorators/dynamic-property.decorator';
export interface IDynamicOption {
  label: string;
  value: string | number;
}
export interface IDynamicOptionsMixin {
  options: IDynamicOption[] | undefined;
  trackByOptionValue: TrackByFunction<IDynamicOption>;
}

export type DynamicOptionsCtor = Constructor<IDynamicOptionsMixin>;

export function mixinDynamicOptions<T extends Constructor<{}>>(base: T): DynamicOptionsCtor & T {
  class DynamicOptionsMixin extends base implements IDynamicOptionsMixin {
    @DynamicProperty() options: IDynamicOption[] | undefined;
    readonly trackByOptionValue = trackByFunctions.byValue;

    constructor(...args: any[]) {
      super(...args);
    }
  }

  return DynamicOptionsMixin;
}
